<template>
  <div v-if="!isLoading" class="member-info">
    <div class="container container-s">
      <div class="member-info__body">
        <div class="member-info__row">
          <div class="member-info__label">{{ $t('memberInfo.label.account') }}</div>
          <div class="member-info__value">{{ MemberForm.memberAccount }}</div>
        </div>

        <div class="member-info__row">
          <div class="member-info__label">{{ $t('memberInfo.label.name') }}</div>
          <div class="member-info__value">{{ MemberForm.memberName }}</div>
        </div>

        <div class="member-info__row">
          <div class="member-info__label">{{ $t('memberInfo.label.address') }}</div>
          <div class="member-info__value member-info__value--with-toggle">
            <span>{{ AddrText }}</span>
            <el-button
              type="text"
              size="small"
              class="member-info__toggle"
              @click="handelSetEncryptModel(1)"
            >
              <i :class="encryptModel & 1 ? 'el-icon-view' : 'el-icon-view'"></i>
            </el-button>
          </div>
          <router-link
            v-if="MemberForm.buttonOpen & 1"
            to="/member/modify"
            class="member-info__action-btn"
          >
            <el-button type="primary" size="small">
              <i class="el-icon-edit"></i>
              {{ $t('memberInfo.button.modifyInfo') }}
            </el-button>
          </router-link>
        </div>

        <div class="member-info__row">
          <div class="member-info__label">{{ $t('memberInfo.label.email') }}</div>
          <div class="member-info__value member-info__value--with-toggle">
            <span>{{ MailText }}</span>
            <el-button
              type="text"
              size="small"
              class="member-info__toggle"
              @click="handelSetEncryptModel(2)"
            >
              <i :class="encryptModel & 2 ? 'el-icon-view' : 'el-icon-view'"></i>
            </el-button>
          </div>
          <el-button
            v-if="MemberForm.buttonOpen & 4"
            type="success"
            size="small"
            class="member-info__action-btn"
            @click="OpenModal(1)"
          >
            <i class="el-icon-check"></i>
            {{ $t('memberInfo.button.verifyEmail') }}
          </el-button>
        </div>

        <div class="member-info__row">
          <div class="member-info__label">{{ $t('memberInfo.label.phone') }}</div>
          <div class="member-info__value member-info__value--with-toggle">
            <span>{{ MobileText }}</span>
            <el-button
              type="text"
              size="small"
              class="member-info__toggle"
              @click="handelSetEncryptModel(4)"
            >
              <i :class="encryptModel & 4 ? 'el-icon-view' : 'el-icon-view'"></i>
            </el-button>
          </div>
          <el-button
            v-if="MemberForm.buttonOpen & 8"
            type="success"
            size="small"
            class="member-info__action-btn"
            @click="OpenModal(2)"
          >
            <i class="el-icon-check"></i>
            {{ PhoneBtn }}
          </el-button>
        </div>

        <el-form
          ref="SchoolForm"
          :model="SchoolForm"
          :rules="SchoolRules"
          class="member-info__form"
          @submit.prevent.native
        >
          <div class="member-info__row">
            <div class="member-info__label">
              {{ $t('memberInfo.label.inSchool') }}
              <span v-if="SchoolModify" class="member-info__required">*</span>
            </div>
            <div class="member-info__value">
              <el-form-item v-if="SchoolModify" prop="inSchool">
                <el-radio-group v-model="SchoolForm.inSchool" class="member-info__radio-group">
                  <el-radio :label="1" class="form-radio">{{ $t('common.yes') }}</el-radio>
                  <el-radio :label="0" class="form-radio">{{ $t('common.no') }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <span v-else>{{ MemberForm.inSchool === 1 ? $t('common.yes') : $t('common.no') }}</span>
            </div>
          </div>

          <div class="member-info__row">
            <div class="member-info__label">
              {{ $t('memberInfo.label.education') }}
              <span v-if="SchoolModify" class="member-info__required">*</span>
            </div>
            <div class="member-info__value">
              <div v-if="SchoolModify" class="member-info__school-form">
                <el-form-item prop="schoolId">
                  <el-select
                    v-model="SchoolForm.schoolId"
                    filterable
                    :placeholder="$t('memberInfo.placeholder.school')"
                    size="large"
                    @change="SetSchoolDept('SchoolForm')"
                  >
                    <el-option
                      v-for="item in SchoolOption"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>

                <el-form-item prop="schoolDeptId">
                  <el-select
                    v-model="SchoolForm.schoolDeptId"
                    filterable
                    :placeholder="$t('memberInfo.placeholder.department')"
                    size="large"
                    @change="SetZipCode()"
                  >
                    <el-option
                      v-for="item in SchoolDeptOption"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>

                <el-form-item v-if="SchoolForm.inSchool" prop="schoolYearId">
                  <el-select
                    v-model="SchoolForm.schoolYearId"
                    :placeholder="$t('memberInfo.placeholder.grade')"
                    size="large"
                    @change="SetZipCode()"
                  >
                    <el-option
                      v-for="item in SchoolYearOption"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </div>
              <span v-else>{{ SchoolText }}</span>
            </div>
          </div>

          <div v-if="SchoolModify" class="member-info__submit">
            <el-button
              type="primary"
              size="large"
              class="member-info__submit-btn"
              @click="ModifyMemberSchool"
            >
              {{ $t('common.button.submit') }}
            </el-button>
          </div>
        </el-form>
      </div>
    </div>

    <!-- 驗證對話框 -->
    <el-dialog
      :title="VerificationTitle"
      :visible.sync="verificationDialogVisible"
      width="600px"
      custom-class="member-info__dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        ref="VerificationForm"
        :model="VerificationForm"
        :rules="VerificationRules"
        class="member-info__verify-form"
        @submit.prevent.native
      >
        <el-alert
          v-if="VerificationType === 1"
          :title="$t('memberInfo.warning.emailNoModify')"
          type="warning"
          :closable="false"
          class="member-info__alert"
        />

        <el-form-item prop="data" class="member-info__field">
          <label class="member-info__label">{{ VerificationType === 1 ? $t('memberInfo.label.email') : $t('memberInfo.label.phone') }}</label>
          <div class="member-info__verify-row">
            <el-input
              v-model="VerificationForm.data"
              :placeholder="VerificationType === 1 ? $t('memberInfo.placeholder.email') : $t('memberInfo.placeholder.phone')"
              size="large"
            />
            <el-button
              type="success"
              size="large"
              :disabled="TimerText !== $t('memberInfo.button.sendCode')"
              class="member-info__verify-btn"
              @click="GetVerification()"
            >
              <i class="el-icon-s-promotion"></i>
              {{ TimerText }}
            </el-button>
          </div>
        </el-form-item>

        <el-form-item prop="verificationCaptchaCode" class="member-info__field">
          <label class="member-info__label">{{ $t('memberInfo.label.verificationCode') }}</label>
          <div class="member-info__verify-row">
            <el-input
              v-model="VerificationForm.verificationCaptchaCode"
              :placeholder="$t('memberInfo.placeholder.verificationCode')"
              size="large"
            />
            <el-button
              type="primary"
              size="large"
              class="member-info__verify-btn"
              @click="HandleVerification()"
            >
              <i class="el-icon-check"></i>
              {{ $t('memberInfo.button.verify') }}
            </el-button>
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="large" @click="verificationDialogVisible = false">
          {{ $t('common.button.close') }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 提示對話框 -->
    <el-dialog
      :title="$t('common.dialog.notice')"
      :visible.sync="NoticeDialog"
      width="500px"
      custom-class="member-info__notice-dialog"
    >
      <div class="member-info__notice">
        <i class="el-icon-warning"></i>
        <p>{{ $t('memberInfo.notice.verifyRequired') }}</p>
        <el-alert
          :title="$t('memberInfo.notice.functionsLocked')"
          type="error"
          :closable="false"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="large" @click="NoticeDialog = false">
          {{ $t('common.button.close') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import SchoolFunc from '@/lib/school';
import { GetCountyList, GetCityList, GetCityByZipCode } from '@/lib/zipcode';
import {
  GetMembetInfoData,
  ModifyMemberMail,
  ModifyMemberPhone,
  BindMemberLine,
  GetSchool,
  GetSchoolDept,
  GetSchoolYear,
  ModifyMemberSchool,
} from '@/api/MemberApi';
import { MemberSendVerification } from '@/api/BaseApi';

/* global $ */
export default {
  data() {
    // 建立你的初始化 model data
    return {
      NoticeDialog: false,
      MemberForm: {
        memberId: 0,
        memberAccount: '',
        memberName: '',
        memberMail: '',
        memberPhone: '',
        memberZipCode: '',
        memberCounty: '',
        memberCity: '',
        memberAddress: '',
        isBindingMail: 0,
        isBindingPhone: 0,
        inSchool: 0,
        schoolId: 0,
        schoolDeptId: 0,
        schoolYearId: 0,
        schoolName: '',
        schoolDeptName: '',
        schoolYearName: '',
        buttonOpen: 0,
      },

      // 取得驗證碼/驗證
      VerificationForm: {
        data: '',
        verificationCaptchaCode: '',
        VerificationGuid: '',
      },
      VerificationRules: {
        data: [
          { required: true, message: this.$t('validation.emailRequired'), trigger: 'blur' },
          { type: 'email', message: this.$t('validation.emailFormat'), trigger: ['blur', 'change'] },
        ],
        memberPhone: [{ required: true, message: this.$t('validation.phoneRequired'), trigger: 'blur' }],
        memberCounty: [{ required: true, message: this.$t('validation.countyRequired'), trigger: 'change' }],
        memberCity: [{ required: true, message: this.$t('validation.cityRequired'), trigger: 'change' }],
        memberAddress: [{ required: true, message: this.$t('validation.addressRequired'), trigger: 'blur' }],
        verificationCaptchaCode: [{ required: true, message: this.$t('validation.verificationCodeRequired'), trigger: 'blur' }],
      },
      CountyOption: [],
      CityOption: [],
      Timer: '',
      TimerText: '',
      VerificationType: 0,
      encryptModel: 7,
      verificationDialogVisible: false, // 驗證對話框可見性

      SchoolFunc: {
        GetSchool,
        GetSchoolYear,
        GetSchoolDept,
      },
      SchoolForm: {
        inSchool: '',
        schoolId: '',
        schoolDeptId: '',
        schoolYearId: '',
      },
      SchoolRules: {
        inSchool: [{ required: true, message: this.$t('validation.inSchoolRequired'), trigger: ['blur', 'change'] }],
        schoolId: [{ required: true, message: this.$t('validation.schoolRequired'), trigger: ['blur', 'change'] }],
        schoolDeptId: [{ required: true, message: this.$t('validation.departmentRequired'), trigger: ['blur', 'change'] }],
        schoolYearId: [{ required: true, message: this.$t('validation.gradeRequired'), trigger: ['blur', 'change'] }],
      },
      SchoolOption: [],
      SchoolDeptOption: [],
      SchoolYearOption: [],
      isLoading: true,
    };
  },
  computed: {
    LineBindingStatus() {
      return this.MemberForm.isBindingLine ? '已綁定' : '未綁定';
    },
    MailStatus() {
      return this.MemberForm.isBindingMail ? '已驗證' : '未驗證';
    },
    PhoneStatus() {
      return this.MemberForm.isBindingPhone ? '已驗證' : '未驗證';
    },
    PhoneBtn() {
      return this.MemberForm.isBindingPhone ? this.$t('memberInfo.button.modifyPhone') : this.$t('memberInfo.button.verifyPhone');
    },
    VerificationTitle() {
      return this.VerificationType === 1 ? this.$t('memberInfo.modal.emailTitle') : this.$t('memberInfo.modal.phoneTitle');
    },
    MobileText() {
      // eslint-disable-next-line no-bitwise
      if ((this.encryptModel & 4) === 4) {
        return this.encryptString(this.MemberForm.memberPhone, 4, 3);
      }
      return this.MemberForm.memberPhone;
    },
    MailText() {
      // eslint-disable-next-line no-bitwise
      if ((this.encryptModel & 2) === 2) {
        const maskMail = this.MemberForm.memberMail.replace(/^(.)(.*)(.@.)(.*)(.com)$/,
          (_, a, b, c, d, e) => a + b.replace(/./g, '*') + c + d.replace(/./g, '*') + e);
        return maskMail;
      }
      return this.MemberForm.memberMail;
    },
    AddrText() {
      const mInfo = this.MemberForm;
      const addStr = `${mInfo.memberZipCode} ${mInfo.memberCounty} ${mInfo.memberCity}`;
      // eslint-disable-next-line no-bitwise
      if ((this.encryptModel & 1) === 1) {
        return `${addStr} ${this.encryptString(mInfo.memberAddress, 0, mInfo.memberAddress.length - 1)}`;
      }
      return `${addStr} ${mInfo.memberAddress}`;
    },
    SchoolText() {
      const mInfo = this.MemberForm;
      const schoolStr = `${mInfo.schoolName} ${mInfo.schoolDeptName} ${mInfo.schoolYearName}`;

      return schoolStr;
    },
    SchoolModify() {
      // eslint-disable-next-line no-bitwise
      return (this.MemberForm.buttonOpen & 32);
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'SchoolForm.inSchool': function () {
      if (this.SchoolForm.inSchool === 0) {
        this.changeInSchool('SchoolForm');
      }
    },
  },
  created() {
    // 一開始執行的地方
    this.init();
  },
  beforeRouteLeave(to, form, next) {
    this.ClearTimer();
    next();
  },
  methods: {
    ...SchoolFunc,
    async  init() {
    // 一開始執行的地方
      await this.GetMemberData();

      this.SetCountyList();
      this.SetCityList(0);
      this.SetZipCode();

      this.GetSchoolList();
      this.GetSchoolYearList();

      this.NoticeDialog = !this.$IsBinding;

      this.isLoading = false;
    },
    encryptString(str, start, length) {
      if (str === '') {
        return '';
      }
      const text = str.replace(str.substr(start, length), '*'.repeat(length));
      return text;
    },
    SetCountyList() {
      this.CountyOption = GetCountyList();
    },
    SetCityList(clear) {
      this.CityOption = GetCityList(this.MemberForm.memberCounty);
      if (clear === 1) {
        this.MemberForm.memberCity = '';
        this.MemberForm.memberZipCode = '';
      } else {
        const data = this.CityOption.filter((item) => this.MemberForm.memberCity === item.label);
        if (!data[0]) {
          this.MemberForm.memberCity = '';
          this.MemberForm.memberZipCode = '';
        }
      }
    },
    SetZipCode() {
      const data = this.CityOption.filter((item) => this.MemberForm.memberCity === item.label);
      if (data[0]) {
        this.MemberForm.memberZipCode = data[0].value;
      } else {
        this.MemberForm.memberZipCode = '';
      }
    },
    // 你的 js function
    GetMemberData() {
      return GetMembetInfoData().then((response) => {
        if (response.data.statusCode === 0) {
          this.MemberForm = response.data.data;
          if (this.MemberForm.memberCity === null || this.MemberForm.memberCity === '') {
            this.MemberForm.memberCity = GetCityByZipCode(this.MemberForm.memberZipCode);
          }
        }
      });
    },

    handelSetEncryptModel(val) {
      // eslint-disable-next-line no-bitwise
      this.encryptModel ^= val;
    },
    // 驗證使用
    OpenModal(type) {
      this.VerificationType = type;
      this.$refs.VerificationForm.resetFields();

      if (type === 1) {
        this.VerificationForm.data = this.MemberForm.memberMail;
        this.VerificationRules.data = [
          { required: true, message: this.$t('validation.emailRequired'), trigger: 'blur' },
          { type: 'email', message: this.$t('validation.emailFormat'), trigger: ['blur', 'change'] },
        ];
      } else {
        this.VerificationForm.data = this.MemberForm.memberPhone;
        this.VerificationRules.data = [
          { required: true, message: this.$t('validation.phoneRequired'), trigger: 'blur' },
          { min: 10, trigger: ['blur', 'change'], message: this.$t('validation.phoneLength') },
          {
            pattern: /^09[0-9]{8}$/,
            message: this.$t('validation.phoneFormat'),
            trigger: 'blur',
          },
        ];
      }
      this.verificationDialogVisible = true;
    },
    GetVerification() {
      this.$refs.VerificationForm.validateField('data', (error) => {
        if (!error) {
          const postData = {
            VerificationType: this.VerificationType,
            VerificationData: this.VerificationForm.data,
          };
          MemberSendVerification(postData).then((response) => {
            if (response.data.statusCode === 0) {
              this.StatrTimer();
              this.VerificationForm.VerificationGuid = response.data.data.verificationGuid;
            }
          });
        }
      });
    },
    StatrTimer() {
      const vm = this;
      const end = vm.$moment(new Date()).add(1, 'minutes');
      this.TiemrFunc(end);
      this.Timer = setInterval(() => this.TiemrFunc(end), 1000);
    },
    ClearTimer() {
      clearInterval(this.Timer);
    },
    TiemrFunc(end) {
      const now = new Date();
      const timeLeft = this.$moment(end).diff(now);
      const timeLeftFormat = this.$moment(timeLeft).format('mm:ss');
      if (timeLeft <= 0) {
        this.ClearTimer();
        this.TimerText = this.$t('memberInfo.button.sendCode');
      } else {
        this.TimerText = `${timeLeftFormat}`;
      }
    },
    HandleVerification() {
      let VerificationFunc = ModifyMemberMail;
      if (this.VerificationType === 2) {
        VerificationFunc = ModifyMemberPhone;
      }

      this.$refs.VerificationForm.validate((valid) => {
        if (valid) {
          VerificationFunc(this.VerificationForm).then((response) => {
            if (response.data.statusCode === 0) {
              const { jwt } = response.data.data;

              if (jwt !== null && jwt !== '') {
                const { ExpTime } = JSON.parse(
                  decodeURIComponent(
                    escape(
                      window.atob(
                        jwt
                          .split('.')[1]
                          .replace(/-/g, '+')
                          .replace(/_/g, '/'),
                      ),
                    ),
                  ),
                );
                const d = new Date(ExpTime);
                document.cookie = `token=${jwt}; expires=${d};path=/`;
                this.$setUserAccount();
              }
              this.$message({
                showClose: true,
                type: 'success',
                message: this.$t('memberInfo.message.verifySuccess'),
              });
              this.ClearTimer();
              this.TimerText = this.$t('memberInfo.button.sendCode');
              this.$nextTick(() => {
                this.GetMemberData();
              });
              this.verificationDialogVisible = false;
            }
          });
        }
      });
    },
    HandleBindingLine() {
      BindMemberLine({
        socialNetwork: 1, // 1:LINE
      }).then((response) => {
        if (response.data.statusCode === 0) {
          // eslint-disable-next-line no-restricted-globals
          location.href = response.data.data;
        }
      });
    },
    ModifyMemberSchool() {
      // 儲存按鈕
      this.$refs.SchoolForm.validate(async (valid) => {
        if (valid) {
          const form = this.SchoolForm;
          const postData = this._.cloneDeep(form);

          postData.schoolId = form.schoolId === '' ? 0 : form.schoolId;
          postData.schoolDeptId = form.schoolDeptId === '' ? 0 : form.schoolDeptId;
          postData.schoolYearId = form.schoolYearId === '' ? null : form.schoolYearId;

          ModifyMemberSchool(postData).then((response) => {
            if (response.data.statusCode === 0) {
              this.$message({
                showClose: true,
                type: 'success',
                message: this.$t('memberInfo.message.modifySuccess'),
              });
              this.init();
            }
          });
        } else {
          this.$message({
            showClose: true,
            type: 'error',
            message: this.$t('common.message.fillAllFields'),
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/_variables.scss';

.member-info {
  padding: var(--spacing-lg) var(--spacing-md);

  &__row {
    display: flex;
    align-items: flex-start;
    padding: var(--spacing-md) 0;
    border-bottom: 1px solid var(--border-lighter);
    gap: var(--spacing-md);

    &:last-child {
      border-bottom: none;
    }
  }

  &__label {
    flex: 0 0 180px;
    font-size: var(--font-size-sm);
    font-weight: 600;
    color: var(--text-primary);
    padding-top: var(--spacing-xs);
  }

  &__required {
    color: #f56c6c;
    margin-left: 4px;
  }

  &__value {
    flex: 1;
    font-size: var(--font-size-base);
    color: var(--text-regular);
    display: flex;
    align-items: center;
    gap: var(--spacing-sm);
    word-break: break-all;

    &--with-toggle {
      justify-content: space-between;
    }
  }

  &__toggle {
    padding: 4px 8px;
    font-size: var(--font-size-base);
    color: var(--text-secondary);

    &:hover {
      color: var(--primary-color);
    }
  }

  &__action-btn {
    flex-shrink: 0;
    text-decoration: none;

    .el-button {
      white-space: nowrap;
    }
  }

  &__form {
    .el-form-item {
      margin-bottom: 0;
    }
  }

  &__radio-group {
    display: flex;
    gap: var(--spacing-lg);

    .el-radio {
      margin-right: 0;
    }
  }

  &__school-form {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: var(--spacing-md);

    .el-form-item {
      margin-bottom: 0;
    }

    .el-select {
      width: 100%;
    }
  }

  &__submit {
    margin-top: var(--spacing-lg);
    padding-top: var(--spacing-lg);
    border-top: 1px solid var(--border-lighter);
    text-align: center;
  }

  &__submit-btn {
    min-width: 200px;
    height: 44px;
    font-size: var(--font-size-base);
    font-weight: 600;
    border-radius: var(--border-radius-base);
    transition: all var(--transition-base);

    i {
      margin-right: var(--spacing-xs);
    }

    &:hover {
      transform: translateY(-2px);
    }
  }

  // 驗證對話框樣式
  &__dialog {
    .el-dialog__header {
      background-color: var(--primary-light-color);
      padding: var(--spacing-lg);
    }

    .el-dialog__body {
      padding: var(--spacing-xl);
    }
  }

  &__verify-form {
    .el-form-item {
      margin-bottom: var(--spacing-lg);

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &__field {
    .member-info__label {
      display: block;
      margin-bottom: var(--spacing-sm);
      font-size: var(--font-size-sm);
      font-weight: 600;
      color: var(--text-primary);
    }
  }

  &__verify-row {
    display: flex;
    gap: var(--spacing-sm);

    .el-input {
      flex: 1;
    }
  }

  &__verify-btn {
    flex-shrink: 0;
    white-space: nowrap;

    i {
      margin-right: var(--spacing-xs);
    }
  }

  &__alert {
    margin-bottom: var(--spacing-lg);
  }

  // 提示對話框樣式
  &__notice-dialog {
    .el-dialog__body {
      padding: var(--spacing-xl);
    }
  }

  &__notice {
    text-align: center;

    i {
      font-size: 64px;
      color: #e6a23c;
      margin-bottom: var(--spacing-md);
    }

    p {
      font-size: var(--font-size-lg);
      color: var(--text-primary);
      margin: var(--spacing-md) 0;
    }

    .el-alert {
      margin-top: var(--spacing-md);
    }
  }

  // Element UI 深度樣式覆蓋
  ::v-deep .el-input__inner {
    &:focus {
      border-color: var(--primary-color);
      box-shadow: 0 0 0 2px var(--primary-light-color);
    }
  }

  ::v-deep .el-select {
    .el-input__inner {
      &:focus {
        border-color: var(--primary-color);
      }
    }
  }

  ::v-deep .el-button--primary {
    background-color: var(--primary-color);
    border-color: var(--primary-color);

    &:hover {
      background-color: #0099d3;
      border-color: #0099d3;
    }
  }

  ::v-deep .el-radio {
    &__inner {
      border-color: var(--primary-color);
    }

    &__input.is-checked {
      .el-radio__inner {
        border-color: var(--primary-color);
        background-color: var(--primary-color);
      }

      + .el-radio__label {
        color: var(--primary-color);
      }
    }

    &__label {
      color: var(--text-regular);
    }
  }

  ::v-deep .el-form-item {
    &.is-error {
      .el-input__inner {
        border-color: #f56c6c;
      }
    }
  }

  // 響應式設計
  @media (max-width: $breakpoint-md) {
    &__school-form {
      grid-template-columns: 1fr 1fr;
    }
  }

  @media (max-width: $breakpoint-sm) {
    padding: var(--spacing-md) var(--spacing-sm);

    &__row {
      flex-direction: column;
      gap: var(--spacing-sm);
      padding: var(--spacing-md) 0;
    }

    &__label {
      flex: none;
      padding-top: 0;
    }

    &__value {
      flex: none;
      width: 100%;

      &--with-toggle {
        flex-direction: row;
      }
    }

    &__action-btn {
      width: 100%;

      .el-button {
        width: 100%;
      }
    }

    &__school-form {
      grid-template-columns: 1fr;
    }

    &__verify-row {
      flex-direction: column;

      .el-input,
      .el-button {
        width: 100%;
      }
    }

    &__submit-btn {
      width: 100%;
    }
  }
}
</style>
